module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-2 28H12V4h16v24zm-3.06-14H20v-3.438c0-.602-.428-.742-.874-.316l-4.818 4.984c-.444.426-.388 1.114.054 1.54l4.738 4.984c.444.426.9.286.9-.316V18h4.94c.552 0 1.06-.446 1.06-1v-2c0-.55-.508-1-1.06-1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/slide-out-left-1.js
// module id = 1418
// module chunks = 14